import { Controller } from "@hotwired/stimulus"

const FILLED = "text-wood-beige"
const EMPTY = "text-stone-200"

export default class extends Controller {
  static targets = ["input", "star"]
  static values = { value: Number }

  connect() {
    this.render(this.valueValue)
  }

  select(event) {
    const rating = Number(event.currentTarget.dataset.star)
    this.valueValue = rating
    this.inputTarget.value = rating
    this.render(rating)
  }

  preview(event) {
    this.render(Number(event.currentTarget.dataset.star))
  }

  reset() {
    this.render(this.valueValue)
  }

  render(rating) {
    this.starTargets.forEach((star) => {
      const filled = Number(star.dataset.star) <= rating
      star.classList.toggle(FILLED, filled)
      star.classList.toggle(EMPTY, !filled)
    })
  }
}
